import { Link } from "react-router-dom";
import Typography from "../Typography/Typography";
import Button from "../Button/Button";
import { Bookmark, FileText, Paperclip } from "lucide-react";
import React, { useState } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import ApiManager from "../../api/ApiManager";
import { useAuth } from "../../store/AuthContext/AuthContext";
import { set } from "lodash";

export default function DocumentCard({
  id,
  awsId,
  isScholar = true,
  isListed = false,
  isResearch = false,
  showNumber = false,
  number = 1,
  journalName = "",
  title = "Default Title",
  siteUrl = "",
  imageUrl = "https://source.unsplash.com/random",
  placeholder = false,
  description = "Default description abstract",
  date = "Jan 1, 2023",
  year = 2024,
  authors = [],
  fieldsOfStudy = [],
  citations = 0,
  hasPdf = false,
  isRatio = true,
  isMobileLibrary = false,
  isHoverTooltip = false,
}) {
  const normalizedUrl = siteUrl
    .replace(/^([a-zA-Z][a-zA-Z\d+\-.]*):\/\/([^\/]+).*/, "$1://$2")
    .replace(/^https?:\/\//, "");
  const normalizedId =
    typeof id === "string"
      ? id.replace(/^.*[\/\\]([a-f0-9\-]+)(?=\.\w+$)/, "$1")
      : "";
  const finalId = siteUrl?.trim() ? normalizedUrl : normalizedId;

  const [isAdded, setIsAdded] = useState(false);

  const { getCookie } = useAuth();
  const api = new ApiManager();

  const handleAddSource = () => {
    const previousState = isAdded;
    setIsAdded(!isAdded);

    if (!previousState) {
      const id_token = getCookie("id_token");
      const projectId = getCookie("project_id");

      const payload = {
        project_id: projectId,
        paper_id: id,
        title: title,
        year: " ",
        authors: ["non", "trovati"],
        journalName: journalName || "",
        fieldsOfStudy: "???",
        isOpenAccess: hasPdf,
        citationCount: citations || 0,
        abstract: description,
        tldr: description,
        url: siteUrl,
        description: description,
      };

      api
        .post("/semanticdocuments", payload, {
          headers: {
            Authorization: `Bearer ${id_token}`,
          },
        })
        .then((response) => {
// TODO: toast
        })
        .catch((error) => {
          console.error("Error adding document:", error);
          setIsAdded(previousState);
        });
    } else {
      const id_token = getCookie("id_token");
      const projectId = getCookie("project_id");

      const payload = {
        project_id: projectId,
        document_id: id,
      };

      api
        .delete("/semanticdocuments/delete", payload, {
          headers: {
            Authorization: `Bearer ${id_token}`,
          },
        })
        .then((response) => {
          // TODO: toast
        })
        .catch((error) => {
          console.error("Error removing document:", error);
          setIsAdded(previousState);
        });
    }
  };

  return (
    <div
      className={`cursor-pointer col-span-full md:col-span-6 lg:col-span-4 xl:col-span-3 flex flex-col gap-3 justify-between ${
        isRatio
          ? "aspect-[4/3]"
          : "max-h-[calc(320px*3/4)] max-w-[calc(320px*3/4)] md:max-w-none"
      } ${isMobileLibrary ? "max-h-none max-w-none" : ""} ${
        isResearch && "max-w-[320px]"
      } overflow-hidden relative`}
    >
      <Link
        to={{
          pathname: isScholar
            ? `/client/library/${id}`
            : `/client/library/${finalId}`,
        }}
        state={{ siteUrl, awsId: awsId }} // Aggiungi awsId all'oggetto state
        className="flex flex-col gap-3 h-full"
      >
        {isScholar ? (
          <div className="flex flex-col gap-2 flex-grow justify-between relative">
            {/* Sezione superiore con URL e info */}
            <div>
              {/* Titolo e numero */}
              <div className="flex flex-row gap-3">
                {showNumber && (
                  <div className="w-6 h-6 flex items-center justify-center bg-gray-150 aspect-square rounded-full">
                    <Typography size="12" weight="md" color="gray-600">
                      {number}
                    </Typography>
                  </div>
                )}
                <span className="truncate">
                  <Typography size="20" weight="sb">
                    {title}
                  </Typography>
                </span>
              </div>

              <div className="flex justify-between items-center max-w-full gap-2 mt-2">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 flex items-center justify-center aspect-square rounded-full overflow-hidden">
                    <img
                      src={`https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${siteUrl}&size=16`}
                      alt="Site Icon"
                    />
                  </div>
                  <div className="max-w-full truncate">
                    <Typography size="12" color="gray-600">
                      {normalizedUrl}
                    </Typography>
                  </div>
                </div>
                <div className="flex gap-3 text-gray-600">
                  {hasPdf && (
                    <div className="flex gap-[6px] items-center">
                      <Paperclip size="12" />
                      <Typography size="12" color="gray-600">
                        1
                      </Typography>
                    </div>
                  )}
                </div>
              </div>

              {/* Autori e campi di studio */}
              {/* <div className="flex flex-col gap-3 mt-2">
                <div className="flex items-center gap-3">
                  <Typography size="12" color="gray-600">
                    {date}
                  </Typography>

                  {Array.isArray(authors) && authors.length > 0 && (
                    <>
                      <div className="w-[2px] h-full bg-gray-150 mx-2" />
                      <ScrollContainer
                        horizontal
                        className="flex flex-row flex-nowrap items-center"
                      >
                        {authors.slice(0, 3).map((author, index) => (
                          <React.Fragment key={index}>
                            <Typography size="12" color="gray-600">
                              {author.name}
                            </Typography>
                            {index < Math.min(authors.length, 3) - 1 && (
                              <div className="w-[2px] h-full bg-gray-150 mx-2" />
                            )}
                          </React.Fragment>
                        ))}
                      </ScrollContainer>
                    </>
                  )}

                  {Array.isArray(fieldsOfStudy) && fieldsOfStudy.length > 0 && (
                    <>
                      {authors.length > 0 && (
                        <div className="w-[2px] h-full bg-gray-150 mx-2" />
                      )}
                      <ScrollContainer
                        horizontal
                        className="flex flex-row flex-nowrap items-center"
                      >
                        {fieldsOfStudy.slice(0, 2).map((field, index) => (
                          <React.Fragment key={`field-${index}`}>
                            <Typography size="12" color="gray-600">
                              {field}
                            </Typography>
                            {index < Math.min(fieldsOfStudy.length, 2) - 1 && (
                              <div className="w-[2px] h-full bg-gray-150 mx-2" />
                            )}
                          </React.Fragment>
                        ))}
                      </ScrollContainer>
                    </>
                  )}
                </div>
              </div> */}

              {/* Descrizione con barra laterale */}
              <div className="flex flex-row gap-3 flex-grow mt-2">
                <div className="w-[2px] min-w-[2px] min-h-full bg-gray-150"></div>
                <span className="leading-[16px]">
                  <Typography size="12" color="gray-600" clampValue="3">
                    {description}
                  </Typography>
                </span>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="flex flex-row gap-3 items-center">
              {showNumber && (
                <div className="w-6 h-6 flex items-center justify-center bg-gray-150 aspect-square rounded-full">
                  <Typography size="12" weight="md" color="gray-600">
                    {number}
                  </Typography>
                </div>
              )}
              <span className="truncate w-full">
                <Typography size="20" weight="sb">
                  {title}
                </Typography>
              </span>
            </div>
            {placeholder ? (
              <div className="w-full h-full rounded-[8px] bg-gray-200 animate-pulse"></div>
            ) : (
              <div className="h-full w-full rounded-[8px] overflow-hidden">
                <img
                  src={imageUrl}
                  alt="Author"
                  className="object-cover object-top w-full h-full"
                />
              </div>
            )}
          </>
        )}
      </Link>
      {isScholar && (
        <>
          {!isListed && (
            <div
              className={`absolute w-full ${
                isHoverTooltip ? "bg-white" : "bg-gray-50"
              } bottom-0 p-2 z-20`}
            >
              <Button
                icon={<Bookmark size="16" />}
                type={isAdded ? "color" : "bw"}
                size="sm"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation(); // Ferma il click da raggiungere il Link
                  handleAddSource();
                }}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}
